<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">The Granville Affair</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#part-one">Part One</a>
<ol class="toc">
<li id="toc-li-2">
<a href="#/text/ch001#shadows-of-destiny">Shadows of Destiny</a>
<ol class="toc">
<li id="toc-li-3">
<a href="#/text/ch001#section">1939–1940</a>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-4">
<a href="#/text/ch002#one">One</a>
</li>
<li id="toc-li-5">
<span href="#/text/ch003#two" title="Link target outside of Sample">Two</span>
</li>
<li id="toc-li-6">
<span href="#/text/ch004#part-two" title="Link target outside of Sample">Part Two</span>
<ol class="toc">
<li id="toc-li-7">
<span href="#/text/ch004#aspects-of-austerity" title="Link target outside of Sample">Aspects of Austerity</span>
<ol class="toc">
<li id="toc-li-8">
<span href="#/text/ch004#section-1" title="Link target outside of Sample">1940–1942</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-9">
<span href="#/text/ch005#three" title="Link target outside of Sample">Three</span>
</li>
<li id="toc-li-10">
<span href="#/text/ch006#four" title="Link target outside of Sample">Four</span>
</li>
<li id="toc-li-11">
<span href="#/text/ch007#five" title="Link target outside of Sample">Five</span>
</li>
<li id="toc-li-12">
<span href="#/text/ch008#part-three" title="Link target outside of Sample">Part Three</span>
<ol class="toc">
<li id="toc-li-13">
<span href="#/text/ch008#into-the-light" title="Link target outside of Sample">Into the Light</span>
<ol class="toc">
<li id="toc-li-14">
<span href="#/text/ch008#section-2" title="Link target outside of Sample">1943–1945</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-15">
<span href="#/text/ch009#six" title="Link target outside of Sample">Six</span>
</li>
<li id="toc-li-16">
<span href="#/text/ch010#seven" title="Link target outside of Sample">Seven</span>
</li>
<li id="toc-li-17">
<span href="#/text/ch011#the-granville-sisters-trilogy" title="Link target outside of Sample">The Granville Sisters Trilogy</span>
</li>
<li class="author_bio">
<span href="#/text/author_bio" title="Link target outside of Sample">About the Author</span>
</li>
<li class="also_by">
<span href="#/text/also_by" title="Link target outside of Sample">Also by Una-Mary Parker</span>
</li>
<li id="toc-li-18">
<span href="#/text/ch012#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?5d841cfd